
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Actions from "../../Components/Ui/tables/Actions";
import { useNavigate } from "react-router-dom";
import { useDeleteDeveloper } from "../../api/Developer";
import ColumnsImage from "../../Components/Columns/ColumnsImage";


const useTableColumns :any = () => {
  const [t] = useTranslation();
  const deleteMutation = useDeleteDeveloper()
  const navigate = useNavigate()
    return useMemo(
    () => [
 
      {
        name: t("id"),
        sortable: true,
        center: true,
        selector: (row: any) => row.id, 
      }, 
      {
        name: t("image"),
        sortable: false,
        center: "true",
        cell: (row:any) =>  {
          let src = row?.image;
          return <ColumnsImage src={src} />
        }
        
      },
      {
        name: t("name"),
        sortable: false,
        center: "true",
        cell: (row:any) => row?.name
      },

      {
        name: t("description"),
        sortable: false,
        center: "true",
        cell: (row:any) => <div className="single-line-div">{row?.description} </div> 
      },
      {
        name: "#",
        sortable: false,
        center: true,
        cell: (row:any) => (
          <Actions
            objectToEdit={row}
            showEdit
            onEdit={()=> navigate(`/developer/${row.id}`) }
            showView={false}
            onDelete={() => deleteMutation.mutate({ id: row.id })}
          >  
          </Actions>
        ),
      },

    ],
    [deleteMutation, navigate, t]
  );
};

export default useTableColumns;

